import InfoIcon from "@mui/icons-material/Info";
import { IconButton } from "@mui/material";
import UtilService from "../../services/UtilService";

export function getColumns(handleDetailClick) {
    return [
        {
            field: "id",
            headerName: "ID",
            flex: 1,
            editable: false,
        },
        {
            field: "name",
            headerName: "Name",
            flex: 2,
            editable: false,
            alignItems: "center",
        },
        {
            field: "startAt",
            headerName: "Start Date",
            flex: 1.5,
            editable: false,
            alignItems: "center",
            renderCell: (params) => {
                return params.value ? UtilService.formatDate(params.value) : "";
            },
        },
        {
            field: "endAt",
            headerName: "End Date",
            flex: 1.5,
            editable: false,
            alignItems: "center",
            renderCell: (params) => {
                return params.value ? UtilService.formatDate(params.value) : "";
            },
        },
        {
            field: "requiredCount",
            headerName: "Required Count",
            flex: 1,
            editable: false,
            alignItems: "center",
        },
        {
            field: "rewardMonths",
            headerName: "Reward Months",
            flex: 1,
            editable: false,
            alignItems: "center",
        },
        {
            field: "createdAt",
            headerName: "Created",
            flex: 1.5,
            editable: false,
            alignItems: "center",
            renderCell: (params) => {
                if (!params.value) return "";
                return UtilService.formatDate(params.value);
            },
        },
        {
            field: "action",
            headerName: "Action",
            flex: 0.8,
            sortable: false,
            editable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
                return (
                    <IconButton
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            if (handleDetailClick) {
                                handleDetailClick(params.row.id);
                            }
                        }}
                        color="primary"
                    >
                        <InfoIcon />
                    </IconButton>
                );
            },
        },
    ];
}

